import React from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Form,
  Input,
  Label,
  Offcanvas,
  OffcanvasBody,
  OffcanvasHeader,
  Table,
} from "reactstrap";
import { MovimientoBaseConfig, MovimientoResumen } from "./MovimientoBase.types";

export type MovimientoListadoProps = {
  config: MovimientoBaseConfig;
  busqueda: string;
  movimientos: MovimientoResumen[];
  filtrosVisibles: boolean;
  onBusquedaChange: (value: string) => void;
  onLimpiarBusqueda: () => void;
  onAbrirFiltros: () => void;
  onCerrarFiltros: () => void;
};

const MovimientoListado: React.FC<MovimientoListadoProps> = ({
  config,
  busqueda,
  movimientos,
  filtrosVisibles,
  onBusquedaChange,
  onLimpiarBusqueda,
  onAbrirFiltros,
  onCerrarFiltros,
}) => (
  <Card>
    <CardHeader className="border-0">
      <div className="d-flex flex-wrap gap-2 align-items-center">
        <div className="flex-grow-1">
          <h5 className="card-title mb-0">Listado de movimientos recientes</h5>
          <p className="text-muted mb-0">
            Revisá las {config.conceptoTitulo.toLowerCase()} registradas en las últimas semanas.
          </p>
        </div>
        <div className="d-flex gap-2 flex-wrap">
          <Button color="soft-success" className="text-nowrap" style={{ minWidth: 150 }}>
            <i className="ri-file-excel-2-line align-middle me-1" />
            Descargar Excel
          </Button>
          <Button color="soft-danger" className="text-nowrap" style={{ minWidth: 150 }}>
            <i className="ri-file-pdf-line align-middle me-1" />
            Descargar PDF
          </Button>
          <Button color="primary" onClick={onAbrirFiltros}>
            <i className="ri-equalizer-line align-middle me-1" />
            Filtros
          </Button>
        </div>
      </div>
    </CardHeader>
    <CardBody className="p-0">
      <Offcanvas direction="end" isOpen={filtrosVisibles} toggle={onCerrarFiltros} scrollable>
        <OffcanvasHeader toggle={onCerrarFiltros}>Filtros de movimientos</OffcanvasHeader>
        <OffcanvasBody>
          <Form
            onSubmit={(e) => {
              e.preventDefault();
              onCerrarFiltros();
            }}
          >
            <div className="mb-4">
              <Label htmlFor="mov-busqueda" className="form-label">
                Buscar por código o cliente
              </Label>
              <Input
                id="mov-busqueda"
                type="search"
                placeholder="Ej: MOV-2026-001"
                value={busqueda}
                onChange={(e) => onBusquedaChange(e.target.value)}
              />
            </div>
            <div className="d-flex justify-content-between gap-2 flex-wrap">
              <Button
                type="button"
                color="link"
                className="text-decoration-none text-reset"
                onClick={onLimpiarBusqueda}
              >
                Limpiar filtros
              </Button>
              <Button type="submit" color="primary">
                Aplicar filtros
              </Button>
            </div>
          </Form>
        </OffcanvasBody>
      </Offcanvas>
      <div className="px-3 pb-3 pt-0">
        <Input
          type="search"
          placeholder="Buscar código, sucursal, origen o cliente"
          value={busqueda}
          onChange={(e) => onBusquedaChange(e.target.value)}
        />
      </div>
      <div className="table-responsive">
        <Table hover className="align-middle mb-0">
          <thead className="table-light">
            <tr>
              <th>Código</th>
              <th>Depósito</th>
              <th>Fecha</th>
              <th>Hora</th>
              <th>Origen</th>
              <th>Destino</th>
              <th>Cliente</th>
              <th>Estado</th>
              <th style={{ width: "140px" }}>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {movimientos.map((mov) => (
              <tr key={mov.codigo}>
                <td className="fw-semibold">{mov.codigo}</td>
                <td>{mov.sucursal}</td>
                <td>{mov.fecha}</td>
                <td>{mov.hora}</td>
                <td>{mov.origen}</td>
                <td>{mov.destino}</td>
                <td>{mov.cliente}</td>
                <td className="text-capitalize">{mov.estado}</td>
                <td>
                  <div className="d-flex gap-2">
                    <Button color="soft-primary" size="sm">
                      <i className="ri-checkbox-circle-line align-middle me-1" />
                      Recepcionar
                    </Button>
                    <Button color="soft-info" size="sm">
                      <i className="ri-eye-line align-middle me-1" />
                      Ver
                    </Button>
                    <Button color="soft-danger" size="sm">
                      <i className="ri-close-circle-line align-middle me-1" />
                      Anular
                    </Button>
                  </div>
                </td>
              </tr>
            ))}
            {movimientos.length === 0 && (
              <tr>
                <td colSpan={9} className="text-center text-muted py-4">
                  No encontramos movimientos para la búsqueda ingresada.
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
    </CardBody>
  </Card>
);

export default MovimientoListado;
